import { Text } from "@/components/customComponents";
import PropTypes from "prop-types";
import { formatNumber } from "@/utils";
import { Icon, IconVariants, IconSize } from "@next-platform/client-common-spicy-ui";

const MessageCounter = ({ num_messages }) => {
  if (!num_messages) return null;
  return (
    <>
      <span className="text-[10px] align-middle flex items-center">
        <Icon icon={IconVariants.MAIL} className="mr-1" size={IconSize.XSMALL} />
        <Text variant={"xxs"}>{formatNumber(num_messages)}</Text>
      </span>
    </>
  );
};
MessageCounter.propTypes = {
  num_messages: PropTypes.number,
};

export default MessageCounter;
